<script>
    export default {
        props: {
            headline: String,
            filter: Object,
            indexes: Object,
            seeDirectoryActions: Boolean,
            showUpperSearchButton: Boolean,
            showLowerSearchButton: Boolean,
            showValidatorToggle: Boolean,
            hideFileNameInput: Boolean,
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            resetFilter() {
                this.$emit('reset');
            },
            startSearch(index) {
                this.$emit('search', index);
                this.loading = true;
            },
            filterValidation: function (value) {
                if (value) {
                    this.$set(this.filter, 'validationOk', 1);
                    this.$set(this.filter, 'validationFailed', null);
                } else {
                    this.$set(this.filter, 'validationFailed', 1);
                    this.$set(this.filter, 'validationOk', null);
                }

                this.startSearch();
            },
        },
    }
</script>

<template>
    <div class="ibox float-e-margins mediafilter">
        <div class="ibox-title">
            <h5 class="text-uppercase">{{ headline }}</h5>
            <div class="ibox-tools">
                <div class="ibox-tools">
                    <a @click="resetFilter()">
                        <i class="fa fa-eraser"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="ibox-content">
            <div class="file-manager">
                <div v-if="showUpperSearchButton">
                    <button @click="startSearch()" class="btn btn-primary btn-block">{{ __('scoop-os.common.search') }}</button>
                    <br/>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <h5 class="lh-34" style="margin: 0;">{{ __('scoop-os.labels.order_by') }}</h5>
                    </div>
                    <div class="col-sm-8">
                        <select class="form-control" v-model="filter.order" @change="startSearch()">
                            <option value="created_at">{{ __('scoop-os.labels.imported_at') }} ↑</option>
                            <option value="created_at_desc" selected>{{ __('scoop-os.labels.imported_at') }} ↓</option>
                            <option value="updated_at">{{ __('scoop-os.labels.updated_at') }} ↑</option>
                            <option value="updated_at_desc" selected>{{ __('scoop-os.labels.updated_at') }} ↓</option>
                            <option value="filename">{{ __('scoop-os.labels.filename') }} ↑</option>
                            <option value="filename_desc">{{ __('scoop-os.labels.filename') }} ↓</option>
                        </select>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <hr class="hr-line-dashed">
                        </div>
                    </div>
                </div>
                <h5 v-if="!hideFileNameInput" class="m-t-md m-b-xs" id="mediaFilterFilenameLabel">{{ __('scoop-os.labels.filename') }}</h5>
                <div v-if="!hideFileNameInput" class="m-b">
                    <input class="form-control" v-model="filter.filename" @keyup.enter="startSearch()" id="mediaFilterFilenameInput">
                </div>
                <slot></slot>
                <div v-if="showValidatorToggle">
                    <h5 class="m-t-md m-b-xs">{{ __('scoop-os.media.validation') }}</h5>
                    <div class="btn-group full-width m-b-md" role="group" :aria-label="__('scoop-os.media.validation')">
                        <button type="button"
                                :class="['btn col-sm-6 btn-sm', filter.validationFailed ? 'btn-warning' : 'btn-default']"
                                @click="filterValidation(0)">
                            <span>{{ __('scoop-os.media.validation_failed') }}</span>
                        </button>
                        <button type="button"
                                :class="['btn col-sm-6 btn-sm', filter.validationOk ? 'btn-success' : 'btn-default']"
                                @click="filterValidation(1)">
                            <span>{{ __('scoop-os.media.validation_ok') }}</span>
                        </button>
                    </div>
                </div>
                <div v-if="showLowerSearchButton">
                    <button @click="startSearch()" class="btn btn-primary btn-block">{{ __('scoop-os.common.search') }}</button>
                    <br/>
                </div>
                <h5 class="m-t-md m-b-xs">{{ __('scoop-os.media.media_indexes') }}</h5>
                <media-directories class="m-b" :see-directory-actions="seeDirectoryActions"></media-directories>
            </div>
        </div>
    </div>
</template>